import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { SORT_OPTIONS } from "../../lib/filters";

export default function SortDropdown({ value = "featured", onChange, compact = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const current = SORT_OPTIONS.find((o) => o.key === value) || SORT_OPTIONS[0];

  return (
    <div ref={ref} className={"relative " + (compact ? "" : "min-w-[220px]")}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={
          "w-full flex items-center justify-between gap-3 px-3 py-2 " +
          "bg-[#141414] border border-[#1F1F1F] text-white " +
          "font-mono text-[12px] uppercase tracking-[0.06em] hover:border-[#FF9F1C] transition-colors"
        }
      >
        <span className="text-[#8A8A8A]">Sort:</span>
        <span className="flex-1 text-left truncate">{current.label}</span>
        <ChevronDown className={"h-4 w-4 transition-transform " + (open ? "rotate-180" : "")} />
      </button>
      {open && (
        <ul
          role="listbox"
          className="absolute right-0 z-30 mt-2 min-w-full bg-[#141414] border border-[#1F1F1F] shadow-lg"
          style={{ boxShadow: "0 8px 24px rgba(0,0,0,0.4)" }}
        >
          {SORT_OPTIONS.map((o) => (
            <li key={o.key}>
              <button
                type="button"
                onClick={() => {
                  onChange(o.key);
                  setOpen(false);
                }}
                className={
                  "block w-full text-left px-3 py-2 font-sans text-[14px] text-white hover:bg-[#0A0A0A] " +
                  (o.key === value ? "text-[#FF9F1C]" : "")
                }
              >
                {o.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
